class CustomRating extends window.HTMLElement {
  connectedCallback() {
    const scrollToId = this.getAttribute('scroll-to');

    if (scrollToId) {
      this.style.cursor = 'pointer';
      this.addEventListener('click', this.handleClick.bind(this));
    }
  }

  handleClick(event) {
    event.preventDefault();
    const scrollToId = this.getAttribute('scroll-to');

    if (!scrollToId) return;

    let targetElement = null;

    targetElement = document.getElementById(scrollToId);

    if (!targetElement) {
      targetElement = document.getElementById('shopify-section-' + scrollToId);
    }

    if (!targetElement) {
      const sections = document.querySelectorAll('[id*="' + scrollToId + '"]');
      if (sections.length > 0) {
        targetElement = sections[0];
      }
    }

    if (!targetElement) {
      targetElement = document.querySelector('[data-section-id="' + scrollToId + '"]');
    }

    if (targetElement) {
      targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }
}

if (!window.customElements.get('custom-rating')) {
  window.customElements.define('custom-rating', CustomRating);
}
